module.exports = __webpack_public_path__ + "img/music-and-brain-magazine.938ec6b8.jpg";